import {
  InterventionEurofinsQuotationsApi,
  InterventionAnalysisApi,
  InterventionAnalysisRequestApi,
  InterventionAnalysisTypeApi,
  InterventionComplementaryAnalysisApi,
  InterventionComplementaryAnalysisRequestApi,
  InterventionExportApi,
  InterventionPreparationsApi,
  InterventionLithologicalLayersApi,
  InterventionMaterialsApi,
  InterventionPurgeSoilGasApi,
  InterventionPurgeSoilGasMeasuresApi,
  InterventionPurgeUndergroundWatersApi,
  InterventionPurgeUndergroundWatersMeasuresApi,
  InterventionSampleApi,
  InterventionSurveyApi,
  InterventionAmbientAirInformationApi,
  InterventionExcavatedGroundsInformationApi,
  InterventionFloorInformationApi,
  InterventionFoodProductsInformationApi,
  InterventionSoilGazInformationApi,
  InterventionUndergroundWaterInformationApi,
  InterventionSurfaceWaterSedimentsInformationApi,
  InterventionWeatherReportApi,
  InterventionCalibrationsVerificationApi,
  InterventionDrillingSecurityApi,
} from "@socotec.io/ssp-back-sdk";
import { sspProjectConfig } from "@/setup/openApiConfig";

export const eurofinsQuotationApi = new InterventionEurofinsQuotationsApi(sspProjectConfig);
export const analysisApi = new InterventionAnalysisApi(sspProjectConfig);
export const analysisRequestApi = new InterventionAnalysisRequestApi(sspProjectConfig);
export const analysisTypeApi = new InterventionAnalysisTypeApi(sspProjectConfig);
export const complementaryAnalysisApi = new InterventionComplementaryAnalysisApi(sspProjectConfig);
export const complementaryAnalysisRequestApi = new InterventionComplementaryAnalysisRequestApi(
  sspProjectConfig,
);
export const sondagesExportApi = new InterventionExportApi(sspProjectConfig);
export const preparationsApi = new InterventionPreparationsApi(sspProjectConfig);
export const lithologicalLayerApi = new InterventionLithologicalLayersApi(sspProjectConfig);
export const materialsApi = new InterventionMaterialsApi(sspProjectConfig);
export const purgeSoilGasApi = new InterventionPurgeSoilGasApi(sspProjectConfig);
export const purgeSoilGasMeasuresApi = new InterventionPurgeSoilGasMeasuresApi(sspProjectConfig);
export const purgeUndergroundWatersApi = new InterventionPurgeUndergroundWatersApi(
  sspProjectConfig,
);
export const purgeUndergroundWatersMeasuresApi = new InterventionPurgeUndergroundWatersMeasuresApi(
  sspProjectConfig,
);
export const sampleApi = new InterventionSampleApi(sspProjectConfig);
export const surveyApi = new InterventionSurveyApi(sspProjectConfig);

export const ambientAirInformationApi = new InterventionAmbientAirInformationApi(sspProjectConfig);
export const excavatedGroundsInformationApi = new InterventionExcavatedGroundsInformationApi(
  sspProjectConfig,
);
export const floorInformationApi = new InterventionFloorInformationApi(sspProjectConfig);
export const foodProductsInformationApi = new InterventionFoodProductsInformationApi(
  sspProjectConfig,
);
export const soilGazInformationApi = new InterventionSoilGazInformationApi(sspProjectConfig);
export const underGroundWaterInformationApi = new InterventionUndergroundWaterInformationApi(
  sspProjectConfig,
);
export const surfaceWaterSedimentsInformationApi =
  new InterventionSurfaceWaterSedimentsInformationApi(sspProjectConfig);
export const weatherReportApi = new InterventionWeatherReportApi(sspProjectConfig);

export const calibrationsVerificationApi = new InterventionCalibrationsVerificationApi(
  sspProjectConfig,
);
export const drillingSecurityApi = new InterventionDrillingSecurityApi(sspProjectConfig);

export const surveysApi = {
  async exportSurveys(projectId) {
    const apiResponse = await sondagesExportApi.interventionSurveysExportRetrieveRaw({
      projectId,
    });
    return apiResponse.raw.arrayBuffer();
  },
};
